import type { AlertsAction } from "./actions";
import { ActionTypes } from "./actionTypes";
import { type Draft, produce } from "immer";
import type { Reducer } from "redux";

import type { DeviceStatusSubscription } from "@cobliteam/common-types";

import {
  type UserAlertSettings,
  type WebData,
  webDataError,
  webDataFetching,
  webDataNotAsked,
  webDataSuccess,
} from "@cobliteam/api-lib";

export interface UserAlertsSettingsState {
  notificationSettingsWebData: WebData<UserAlertSettings[]>;
  updateAlertSettingsWebData: WebData<void>;
  deviceStatusSubscriptionWebData: WebData<DeviceStatusSubscription>;
  updateDeviceStatusSubscriptionWebData: WebData<void>;
}

export const userAlertsSettingsInitialState: UserAlertsSettingsState = {
  notificationSettingsWebData: webDataNotAsked(),
  updateAlertSettingsWebData: webDataNotAsked(),
  deviceStatusSubscriptionWebData: webDataNotAsked(),
  updateDeviceStatusSubscriptionWebData: webDataNotAsked(),
};

export const userAlertsSettingsReducer: Reducer<
  UserAlertsSettingsState,
  AlertsAction
> = produce((draft: Draft<UserAlertsSettingsState>, action: AlertsAction) => {
  switch (action.type) {
    case ActionTypes.LOAD_ALERT_SETTING_REQUEST:
      draft.notificationSettingsWebData = webDataFetching();
      break;

    case ActionTypes.LOAD_ALERT_SETTING_SUCCEEDED:
      draft.notificationSettingsWebData = webDataSuccess(action.payload);
      break;

    case ActionTypes.LOAD_ALERT_SETTING_FAILED:
      draft.notificationSettingsWebData = webDataError();
      break;

    case ActionTypes.UPDATE_ALERT_SETTING_REQUEST:
      draft.updateAlertSettingsWebData = webDataFetching();
      break;

    case ActionTypes.UPDATE_ALERT_SETTING_END:
      draft.updateAlertSettingsWebData = webDataNotAsked();
      break;

    case ActionTypes.LOAD_DEVICE_STATUS_SUBSCRIPTION_REQUEST:
      draft.deviceStatusSubscriptionWebData = webDataFetching();
      break;

    case ActionTypes.LOAD_DEVICE_STATUS_SUBSCRIPTION_SUCCEEDED:
      draft.deviceStatusSubscriptionWebData = webDataSuccess(action.payload);
      break;

    case ActionTypes.LOAD_DEVICE_STATUS_SUBSCRIPTION_FAILED:
      draft.deviceStatusSubscriptionWebData = webDataError();
      break;

    case ActionTypes.UPDATE_DEVICE_STATUS_SUBSCRIPTION_REQUEST:
      draft.updateDeviceStatusSubscriptionWebData = webDataFetching();
      break;

    case ActionTypes.UPDATE_DEVICE_STATUS_SUBSCRIPTION_END:
      draft.updateDeviceStatusSubscriptionWebData = webDataNotAsked();
      break;
  }
}, userAlertsSettingsInitialState);
